import React, { useMemo } from 'react';
import Modal2, { type Modal2Props } from '@niaratech/niara-react-components/lib/controls/Modal2';
import { IconButton } from '@mui/material';
import { NiaraIcon } from '@niaratech/niara-icons';
import { useEffectOnChange, useIsMobile } from '@niaratech/niara-react-components';
import { useTheme } from 'styled-components';
import * as S from './styles';
export type ModalOTAProps = React.PropsWithChildren<Modal2Props> & {
  title?: React.ReactNode;
  customTitleRender?: (p: {
    hide: () => void;
  }) => React.ReactNode;
  stickyHeader?: boolean;
  backgroundColor?: string;
  bodyBackgroundColor?: string;
  closeButtonColor?: string;
  closeButtonSize?: number;
  hideHeader?: boolean;
  onScroll?: React.UIEventHandler;
};
const ModalOTA: React.FC<ModalOTAProps> = ({
  title,
  customTitleRender,
  backgroundColor,
  bodyBackgroundColor,
  closeButtonColor,
  hideHeader,
  render,
  children,
  showCloseButton,
  ...props
}) => {
  const isMobile = useIsMobile();
  const lockBodyScroll = useMemo(() => {
    if (!isMobile && ['full', 'side'].includes(props?.desktopVariant)) return true;
    if (isMobile && ['full', 'side'].includes(props?.mobileVariant)) return true;
    return false;
  }, [isMobile, props?.desktopVariant, props?.mobileVariant]);
  useEffectOnChange(() => {
    if (props.show && lockBodyScroll) {
      document.body.style.overflow = 'hidden';
      return () => {
        if (lockBodyScroll) {
          document.body.style.overflow = 'visible';
        }
      };
    }
  }, [props.show]);
  const theme = useTheme();
  return <Modal2 {...props} showCloseButton={false} render={renderProps => {
    return <S.Container backgroundColor={backgroundColor} mobileVariant={props.mobileVariant}>
            {!hideHeader && !customTitleRender && <S.Header>
                <S.Title data-testid="modal-title">{title}</S.Title>
                {showCloseButton !== false && <IconButton size="small" onClick={renderProps.hide} data-testid="close-btn">
                    <NiaraIcon color={closeButtonColor ?? theme?.colors?.textColor} icon="sysClose" size={24} />
                  </IconButton>}
              </S.Header>}
            {hideHeader && showCloseButton && !customTitleRender && <S.FloatingCloseButton>
                <IconButton size="small" onClick={renderProps.hide} data-testid="close-btn">
                  <NiaraIcon color={closeButtonColor ?? theme?.colors?.textColor} icon="sysClose" size={24} />
                </IconButton>
              </S.FloatingCloseButton>}
            {customTitleRender && customTitleRender(renderProps)}

            <S.Content className="modalOTA-content" {...props} backgroundColor={bodyBackgroundColor}>
              {render(renderProps)}
            </S.Content>
          </S.Container>;
  }}>
      {children}
    </Modal2>;
};
export default ModalOTA;